"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var provide_decorator_factory_1 = require("../factory/provide_decorator_factory");
function autoProvide(container) {
    var modules = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        modules[_i - 1] = arguments[_i];
    }
    var provide = provide_decorator_factory_1.default(container);
    modules.forEach(function (module) {
        Object.keys(module).forEach(function (key) {
            var entity = module[key];
            var decorator = provide(entity);
            inversify_1.decorate(decorator, entity);
        });
    });
}
exports.default = autoProvide;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify-binding-decorators/lib/utils/auto_wire.js
// module id = 1179
// module chunks = 0